module.exports = __webpack_public_path__ + "05_hair_silver.41481656.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/05_hair_silver.png
// module id = mQTJ
// module chunks = 0